module.exports = __webpack_public_path__ + "static/thumbnail-f804b195ec8128b29f1b0eca6820f6b0.png";